import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, AUTH, PLATFORM } from '@const'
import * as utils from '@utils'
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    FormControlLabel,
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Switch,
} from '@material-ui/core'
import { Spin, Icon } from 'antd';

const CMS_TYPE_NEW = 'new',
    CMS_TYPE_BELONG = 'belong'

const initialState = {
    platformName: '',
    subPfID: '',
    cmsRoleName: '',
    cmsUserAccount: '',
    cmsType: CMS_TYPE_NEW,
    rootRoleList: [],
    belongRootRoleID: 0,
    pfIDList: [],
    pfIDCheckMap: {},
    authorization_list: {},
    isSupportSingleWallet: false,
    display_currency: false,
    display_rtp: false,
    display_logo: true
}

class AddPlatformDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'AddPlatformDialog')
        }
        this.state = {
            dialogOpen: false,
            ...initialState,
            valid: false,
            loading: false
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset() {
        utils.apiRequest(
            'get',
            API.ROLE_LIST,
            {},
            (data) => {
                /** 篩選總代理角色 */
                const rootRoleList = data.filter((elem) => elem['id'] === elem['root_role_id'] && elem['id'] !== AUTH.ROLE_ID_ADMIN)
                /** 角色排序 */
                const rootSortRoleList = utils.convertSort({ source: rootRoleList })
                /** 篩選可用幣別 */
                const pfIDList = []
                PLATFORM.PF_INFO.forEach((elem) => {
                    const is_enable = this.props.dataService.exchangeCurrencyMap[elem.currency]?.is_enable
                    is_enable && pfIDList.push(elem.pfID)
                })
                /** 檢查幣別列表 */
                if (pfIDList.length === 0) {
                    utils.addToast(this.t('noCurrencyForAdd'), 'error')
                    return false
                }
                /** 幣別排序 */
                const sortPfIDList = utils.sortPlatform(pfIDList)   
                /** 預設幣別不勾選 */
                const pfIDCheckMap = {}
                sortPfIDList.forEach((pfID) => {
                    pfIDCheckMap[pfID] = false
                })
                this.setState({
                    ...initialState,
                    pfIDList: sortPfIDList,
                    pfIDCheckMap: pfIDCheckMap,
                    authorization_list: utils.getRecommendationAuthMap()[AUTH.RECOMMENDATION_AUTH_ROOT_ROLE],
                    rootRoleList: rootSortRoleList,
                    belongRootRoleID: rootSortRoleList[0] ? rootSortRoleList[0]['id'] : 0,
                })
            },
            (_err) => {},
            true
        )
    }

    OpenDialog() {
        this.reset()
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false, valid: false, loading: false })
    }

    confirm(subPfID, checkedPfIDList, currentAddPlatform, cmsUser) {
        if (this.props.confirmCallback) {
            this.props.confirmCallback(subPfID, checkedPfIDList, currentAddPlatform, cmsUser)
        }
        this.closeDialog()
    }

    handlePfNameValid() {
        let valid = false
        valid = Boolean(this.state.platformName.trim())
        return valid
    }

    handlePfCodeValid() {
        let valid = false
        const reg = /^[\dA-Za-z]+$/
        valid = this.state['subPfID'] && reg.test(this.state['subPfID']) && String(this.state['subPfID']).length === 4
        return valid || false
    }

    handleNewAccountValid() {
        let valid = false
        valid = Boolean(this.state.cmsUserAccount.trim())
        return valid
    }

    handleRoleNameValidation() {
        let valid = false
        valid = !this.state.cmsRoleName.trim() || (this.state.cmsRoleName && String(this.state.cmsRoleName).length <= 20)
        return valid
    }

    handleSubmit() {
        this.setState({
            valid: true
        })
        const valid = []
        /** 幣別驗證 */
        const pfIDCheckMapValid = Object.values(this.state.pfIDCheckMap).find((value) => {
            return value
        })
        if (!pfIDCheckMapValid) {
            utils.addToast(this.t('pfIDCheckMapValid'), 'error')
            valid.push(pfIDCheckMapValid ? true : false)
        }
        /** 平台名稱驗證  */
        valid.push(this.handlePfNameValid())
        /** 平台代碼驗證 */
        valid.push(this.handlePfCodeValid())
        /** 總代角色名稱驗證 */
        valid.push(this.handleRoleNameValidation())
        /** 新總代理帳號驗證 */
        if (this.state.cmsType === CMS_TYPE_NEW) {
            valid.push(this.handleNewAccountValid())
        }
        if (valid.find(value => !value) === false) { return }

        /** 總代角色名稱去前後空白 */
        if (this.state.cmsRoleName !== this.state.cmsRoleName.trim()) {
            this.setState({
                cmsRoleName: this.state.cmsRoleName.trim()
            })
        }

        const checkedPfIDList = []

        Object.entries(this.state.pfIDCheckMap).forEach(([key, elem]) => {
            if (elem) checkedPfIDList.push(key)
        })
        this.setState({
            loading: true
        })
        const params = {
            pf_id: checkedPfIDList,
            name: this.state.platformName,
            sub_pf_id: this.state.subPfID,
            is_support_single: this.state.isSupportSingleWallet,
            display_currency: this.state.display_currency,
            display_rtp: this.state.display_rtp,
            display_logo: this.state.display_logo
        }
        const pfSubPfIDList = []
        checkedPfIDList.forEach((pfID) => {
            pfSubPfIDList.push(utils.ComposePfSubPfId(pfID, this.state.subPfID.toUpperCase()))
        })
        let rootRole = null
        let cmsUser = null
        if (this.state.cmsType === CMS_TYPE_NEW) {
            cmsUser = {
                account: `${this.state.cmsUserAccount}`,
                password: utils.generatePassword(utils.getRandomLength()),
            }
            params['root_role_user_both'] = {
                role_name: this.state.cmsRoleName.trim() ? this.state.cmsRoleName.trim() : this.state.platformName,
                pf_sub_pf_id_list: pfSubPfIDList,
                authorization_list: this.state.authorization_list,
                account: cmsUser.account,
                password: cmsUser.password,
                user_name: "Administrator"
            }
        } else {
            rootRole = utils.ArrayToObject(this.state.rootRoleList, 'id')[this.state.belongRootRoleID]
            if (rootRole) {
                params['role_update'] = {
                    id: rootRole['id'],
                    pf_sub_pf_id_list: [...rootRole['pf_sub_pf_id_list'], ...pfSubPfIDList]
                }
            }
        }
        
        utils.apiRequest(
            'post',
            API.PLATFORM_CREATED,
            params,
            (_data) => {
                const currentAddPlatform = {}
                _data.forEach(value => {
                    currentAddPlatform[value.pf_sub_pf_id] = value.key
                })
                if (this.state.cmsType === CMS_TYPE_NEW) {
                    this.confirm(this.state.subPfID, checkedPfIDList, currentAddPlatform, cmsUser)
                } else {
                    rootRole && this.confirm(this.state.subPfID, checkedPfIDList, currentAddPlatform, null)
                }
                this.setState({
                    loading: false
                })
            },
            (_error) => {
                this.setState({
                    loading: false
                })
            }
        )
    }
    antIcon() {
        return <Icon type="loading" style={{ fontSize: 18 }} spin />
    }

    render() {
        return (
            <Dialog maxWidth="sm" fullWidth open={this.state.dialogOpen}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} className={this.props.classes.root}>
                        {this.state.pfIDList.map((pfID) => (
                            <Grid item xs={3} key={pfID}>
                                <FormControlLabel
                                    className={this.props.classes.labelReset}
                                    control={
                                        <Checkbox
                                            checked={this.state.pfIDCheckMap[pfID]}
                                            onChange={(event) => {
                                                this.setState({
                                                    pfIDCheckMap: {
                                                        ...this.state.pfIDCheckMap,
                                                        [pfID]: event.target.checked,
                                                    },
                                                })
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label={this.t('Currency.' + utils.getPfCurrency(pfID))}
                                />
                            </Grid>
                        ))}
                        <Grid item xs={12}>
                            <TextField
                                label={this.t('platformName')}
                                InputLabelProps={{ shrink: true }}
                                value={this.state.platformName}
                                onChange={(event) => this.setState({ platformName: event.target.value })}
                                margin="dense"
                                fullWidth
                                required={true}
                                error={this.state.valid && !this.handlePfNameValid()}
                                helperText={this.state.valid && !this.handlePfNameValid() ? this.t('pfNameValid') : ''}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={this.t('subPfId')}
                                InputLabelProps={{ shrink: true }}
                                value={this.state.subPfID}
                                onChange={(event) => this.setState({ subPfID: event.target.value })}
                                margin="dense"
                                fullWidth
                                required={true}
                                error={this.state.valid && !this.handlePfCodeValid()}
                                helperText={this.state.valid && !this.handlePfCodeValid() ? this.t('subPfIdValid') : ''}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                className={this.props.classes.labelReset}
                                control={
                                    <Checkbox
                                        checked={this.state.isSupportSingleWallet}
                                        onChange={(event) => {
                                            this.setState({
                                                isSupportSingleWallet: event.target.checked,
                                            })
                                        }}
                                        color="primary"
                                    />
                                }
                                label={this.t('isSupportSingleWallet')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                className={this.props.classes.labelReset}
                                control={
                                    <Switch
                                        checked={this.state.display_currency}
                                        onChange={(event) => {
                                            this.setState({ display_currency: event.target.checked })
                                        }}
                                        value="Status"
                                        color="primary"
                                        inputProps={{ 'aria-label': 'Status' }}
                                    />
                                }
                                label={this.t('displayCurrencySymbolsInGame')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                className={this.props.classes.labelReset}
                                control={
                                    <Switch
                                        checked={this.state.display_rtp}
                                        onChange={(event) => {
                                            this.setState({ display_rtp: event.target.checked })
                                        }}
                                        value="Status"
                                        color="primary"
                                        inputProps={{ 'aria-label': 'Status' }}
                                    />
                                }
                                label={this.t('displayRTPDeclarationInGame')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                className={this.props.classes.labelReset}
                                control={
                                    <Switch
                                        checked={this.state.display_logo}
                                        onChange={(event) => {
                                            this.setState({ display_logo: event.target.checked })
                                        }}
                                        value="Status"
                                        color="primary"
                                        inputProps={{ 'aria-label': 'Status' }}
                                    />
                                }
                                label={this.t('displayBrandLogo')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl margin="dense" style={{ width: 240 }}>
                                <InputLabel htmlFor="age-simple">{this.t('cmsType')}</InputLabel>
                                <Select
                                    value={this.state.cmsType}
                                    onChange={(event) =>
                                        this.setState({
                                            cmsType: event.target.value,
                                        })
                                    }>
                                    <MenuItem value={CMS_TYPE_NEW}>{this.t(`createNewCmsUser`)}</MenuItem>
                                    <MenuItem value={CMS_TYPE_BELONG}>{this.t(`belongRootRole`)}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {this.state.cmsType === CMS_TYPE_NEW ? (
                            <React.Fragment>
                                <Grid item xs={12}>
                                    <TextField
                                        label={this.t('cmsRoleName')}
                                        InputLabelProps={{ shrink: true }}
                                        value={this.state.cmsRoleName}
                                        onChange={(event) => 
                                            this.setState({
                                                cmsRoleName: event.target.value
                                            })
                                        }
                                        margin="dense"
                                        fullWidth
                                        error={this.state.valid && !this.handleRoleNameValidation()}
                                        helperText={this.state.valid && !this.handleRoleNameValidation() ? this.t('nameValidError'): ''}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={this.t('cmsUserAccount')}
                                        InputLabelProps={{ shrink: true }}
                                        value={this.state.cmsUserAccount}
                                        onChange={(event) => this.setState({ cmsUserAccount: event.target.value.trim() })}
                                        margin="dense"
                                        fullWidth
                                        required={true}
                                        error={this.state.valid && !this.handleNewAccountValid()}
                                        helperText={this.state.valid && !this.handleNewAccountValid() ? this.t('cmsUserAccountValid') : ''}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : (
                            <Grid item xs={12}>
                                <FormControl margin="dense" style={{ width: 240 }}>
                                    <InputLabel htmlFor="age-simple">{this.t('rootRole')}</InputLabel>
                                    <Select
                                        value={this.state.belongRootRoleID}
                                        onChange={(event) =>
                                            this.setState({
                                                belongRootRoleID: event.target.value,
                                            })
                                        }>
                                        {this.state.rootRoleList.map((rootRole) => (
                                            <MenuItem value={rootRole['id']} key={rootRole['id']}>
                                                {rootRole['name']}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => this.handleSubmit()}
                        color="primary"
                        disabled={this.state.loading}
                    >
                        {this.state.loading && <Spin indicator={this.antIcon()} className={this.props.classes.loadingIcon} />}
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        root: {
            alignItems: 'center',
        },
        labelReset: {
            marginBottom: 0
        },
        loadingIcon: {
            marginRight: _theme.spacing(1),
            color: '#fff',
            lineHeight: 1
        },

    }
}

AddPlatformDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    dataService: PropTypes.object,
}

export default hoc(styles)(AddPlatformDialog)
